
import { defineComponent, SetupContext, PropType } from "vue";
import { RecipeDetailInfo, InstructionItem, Variation, Theme } from "@/types/recipes";
import DetailIngredientsView from "./DetailIngredientsView.vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "ApplianceDialog",
  components: { DetailIngredientsView },
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    showDialog: {
      type: Boolean,
      default: false
    },
    detail: {
      type: RecipeDetailInfo,
      require: true
    },
    selectThemeType: {
      type: String,
      require: true
    },
    selectVariationType: {
      type: String,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const onClickClose = () => {
      context.emit("close-click");
    };
    const getContent = () => {
      return props.detail && props.detail.info
        ? props.detail.info.content
        : null;
    };

    const getInstructions = () => {
      const items = Array<InstructionItem>();
      if (
        props.detail &&
        props.detail.info &&
        props.detail.info.content &&
        props.detail.info.content.instructions
      ) {
        let i = 0;
        for (const instruction of props.detail.info.content.instructions) {
          const lastItem =
            i == props.detail.info.content.instructions.length - 1;
          items.push(new InstructionItem(i++, instruction, lastItem));
        }
      }
      return items;
    };

    const getThemeList = () => {
      let result = null;
      if (props.detail && props.detail.info) {
        if (props.detail.info.themes && props.detail.info.themes.length >= 1) {
          result = props.detail.info.themes;
        } else if (props.detail.info.content && props.detail.info.content.theme) {
          const result = new Array<Theme>();
          result.push(props.detail.info.content.theme);
        }
      }
      NativeClient.sendDebugLog("IngredientsDialog getThemeList result=" + JSON.stringify(result));
      return result;
    };

    const getVariationList = () => {
      let result = null;
      if (props.detail && props.detail.info) {
        if (props.detail.info.variation && props.detail.info.variation.length >= 1) {
          result = props.detail.info.variation;
        } else if (props.detail.info.content && props.detail.info.content.servings) {
          result = new Array<Variation>();
          result.push(props.detail.info.content.servings);
        }
      }
      NativeClient.sendDebugLog("IngredientsDialog getVariationList result=" + JSON.stringify(result));
      return result;
    };

    const getSelectThemeType = () => {
      return props.selectThemeType;
    };

    const getSelectVariationType = () => {
      return props.selectVariationType;
    };

    const clickTheme = (type: string) => {
      context.emit("click-theme", type);
    };

    const clickVariation = (type: string) => {
      context.emit("click-variation", type);
    };
    return {
      onClickClose,
      getContent,
      getInstructions,
      getThemeList,
      getVariationList,
      getSelectThemeType,
      getSelectVariationType,
      clickTheme,
      clickVariation
    };
  }
});
